<div class="agents-page">
  <!-- Header -->
  <div class="header">
    <span class="icon">
      <img src="assets/icones/briefcase.svg" alt="">
    </span>
    {{ "agent.title" | translate }}
  </div>
  <!-- Tabs -->
  <div class="tabs">
    <div
      class="tab"
      role="tab"
      [attr.aria-selected]="activeTab === 'agents'"
      [class.active]="activeTab === 'agents'"
      (click)="activeTab = 'agents'"
    >
    {{ "agent.title" | translate }}
    </div>
    <div
      class="tab"
      role="tab"
      [attr.aria-selected]="activeTab === 'commissions'"
      [class.active]="activeTab === 'commissions'"
      (click)="activeTab = 'commissions'"
    >
    {{ "commission.title" | translate }}
    </div>
  </div>
  <ng-container *ngIf="activeTab === 'agents'">
    <app-agents-listing></app-agents-listing>
  </ng-container>
  <ng-container *ngIf="activeTab === 'commissions'">
    <app-commissions-listing></app-commissions-listing>
  </ng-container>
</div>
